import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { WebUserService } from '../../../services/webuser.service';

@Component({
  selector: 'app-user-profile-picker',
  templateUrl: './user-profile-picker.component.html',
  styleUrls: ['./user-profile-picker.component.scss']
})
export class UserProfilePickerComponent implements OnInit {
  @Input() userId: number;
  @Output() onProfileSet = new EventEmitter<any>();
  placeholder: string = 'Please Select';
  userProfiles = [];

  constructor(private webUserService: WebUserService) {
  }

  ngOnInit(): void {
    this.webUserService.getProfiles().then((profiles) => {
      this.userProfiles = profiles;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.userId != null && changes.userId.currentValue != null) {
      if (this.userId != changes.userId.currentValue != null)
        this.userId = changes.userId.currentValue;

      //console.log("coompany id chaged to: " + this.userId);

      var company = this.userProfiles.find(a => a.id == this.userId);
      this.placeholder = company.typeName;
    }

  }

  userChanged(user) {
    this.onProfileSet.emit(user);
  }

}
